import { ErrorMessage } from "formik";
import React from "react";

import * as styles from "./FieldErrorMessage.module.css";

type ErrorMessageProps = Readonly<{
  fieldName: string;
}>;

export const FieldErrorMessage = ({ fieldName }: ErrorMessageProps) => (
  <ErrorMessage component="div" name={fieldName} className={styles.error} />
);
